module.exports = __webpack_public_path__ + "static/media/correos-express.f3bf678d.svg";